
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carousel-generator",
      function () {
        return require("private-next-pages/carousel-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carousel-generator"])
      });
    }
  